import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../redux/initialStoreState";
import { Alert, IconButton, Snackbar } from "@mui/material";
import { useDispatchWrapper } from "../../hooks";
import { hideMessage } from "../../redux/messages/messagesActions";
import CloseIcon from "@mui/icons-material/Close";
import LoadingDialog from "../Dialogs/LoadingDialog";
import { SuccessErrorDialog } from "../MessagesDialogs/SuccessErrorDialog/SuccessErrorDialog";

export const MessageBox: React.FC = () => {
  const { item, saveLoader, loader_with_message } = useSelector(
    (storeState: IStoreState) => storeState.message
  );

  const dispatch = useDispatchWrapper();

  const handleClearMessage = () => {
    dispatch(hideMessage());
  };

  if (item) {
    if (item.displayAs === "snackbar") {
      return (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={true}
          autoHideDuration={5000}
          onClose={handleClearMessage}
          key={"topright"}
        >
          <Alert
            severity={item.type}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={handleClearMessage}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {item.message}
          </Alert>
        </Snackbar>
      );
    } else if (item.displayAs === "dialog") {
      return (
        <SuccessErrorDialog
          open={true}
          type={item.type}
          content={item.message}
          onClose={handleClearMessage}
        ></SuccessErrorDialog>
      );
    }
  }
  if (saveLoader) {
    return <LoadingDialog open={saveLoader} />;
  }

  if (loader_with_message.loading) {
    return (
      <LoadingDialog
        open={loader_with_message.loading}
        label={loader_with_message.message || "Loading"}
      />
    );
  }

  return <></>;
};
